
// import { createContext, useContext, useEffect, useState } from "react";

// const SettingsContext = createContext();

// export const useSettings = () => useContext(SettingsContext);

// export const SettingsProvider = ({ children }) => {
//   const [settings, setSettings] = useState({
//     logo: "",
//     name: "",
//     email: "",
//     emailNotif: true,
//     systemNotif: false,
//   });

//   // 🔹 load from localStorage
//   useEffect(() => {
//     const stored = localStorage.getItem("appSettings");
//     if (stored) {
//       setSettings((prev) => ({
//         ...prev,
//         ...JSON.parse(stored), // merge safe
//       }));
//     }
//   }, []);

//   // 🔹 save to localStorage
//   useEffect(() => {
//     localStorage.setItem("appSettings", JSON.stringify(settings));
//   }, [settings]);

//   // 🔹 update single field
//   const updateSettings = (key, value) => {
//     setSettings((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   return (
//     <SettingsContext.Provider value={{ settings, updateSettings }}>
//       {children}
//     </SettingsContext.Provider>
//   );
// };

import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    logo: "",
    name: "",
    email: "",
    emailNotif: true,
    systemNotif: false,
  });

  // load only
  useEffect(() => {
    const stored = localStorage.getItem("appSettings");
    if (stored) {
      setSettings((prev) => ({
        ...prev,
        ...JSON.parse(stored),
      }));
    }
  }, []);

  const updateSettings = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const saveSettings = () => {
    localStorage.setItem("appSettings", JSON.stringify(settings));
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings, saveSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};